import React from "react";

const Receptionist = React.lazy(() => import("../pages/home/receptionist/Receptionist"));

export const receptionistRoutes = [
  {
    path: "/receptionist",
    element: <Receptionist />,
    title: "Receptionist Dashboard",
    description: "Central hub for receptionists to manage their daily tasks and interactions.",
  },
];
